GatorSurvey.app.directive('gsSurveyLivePage', ['recaptchaService', '$timeout', '$sce', SurveyLivePage]);

function SurveyLivePage(recaptchaService, $timeout, $sce) {
    return {
        require: '?ngModel',
        restrict: 'AE',
        scope: {
            page: "=ngModel",
            surveyData: "=?",
            numberOfPages: "=?",
            nextPage: "=?",
            backPage: "=?",
            submitPage: "=?",
            allowRetake: "=?",
            retakeSurvey: "=?",
            isSubmit: "=?",
            submitted: "=submitted",
            oneSubmissionMessage: "=?"
        },
        templateUrl: 'Assets/Scripts/App/Directives/Live/Templates/SurveyLivePage.html',
        controller: [
            '$scope', '$q', 'recaptchaService', function ($scope, $q) {
              
                $scope.renderHtml = function (html) {
              
                    return $sce.trustAsHtml(html);
                };

                $scope.recaptcha = {};
                $scope.recaptcha.publicKey = recaptchaService.PublicKey;
                $scope.recaptcha.response = null;
                $scope.recaptcha.widgetId = null;

                function recaptchaCallback() {
                    var responseData = { response: recaptchaService.getResponse($scope.recaptcha.widgetId) };
                    recaptchaService.VerifyRecaptcha(responseData).then(function (data) {
                        if (data)
                            recaptchaService.passed = true;
                        else {
                            recaptchaService.passed = false;
                            recaptchaService.reset($scope.recaptcha.widgetId);
                        }
                    }, function () {
                       
                    });
                }

                $scope.recaptchaElementLoad = function () {
                    console.log("recaptcha:" + recaptchaService.passed);
                    if (!recaptchaService.passed)
                        $(document).ready(function() {
                            $scope.recaptcha.widgetId = recaptchaService.create('recaptchaBtn',
                                { sitekey: $scope.recaptcha.publicKey, callback: recaptchaCallback });
                        });
                };

                $scope.submit = function () {
                    recaptchaCallback();
                };

            }
        ]
    };
}